import './../../../vendor/gsap/TweenMax.min.js'
import Transition from './transition-abstract'

class ScrollTransition extends Transition {
	setup() {
		this.observer = new IntersectionObserver((entries, observer) => {
			entries.forEach(entry => {
				const element = entry.target
				const animation = element.dataset.intersection
				if (element.dataset.intersection != '') {
					// Doing this here because if we did it in CSS and
					// the JS doesn't work... => no shows for everything.
					// (Been there, seen that)
					element.style.opacity = 0;
				}
				if (entry.isIntersecting || entry.intersectionRatio > 0) {
					observer.unobserve(element)
					if (this[`${animation}Animation`]) {
						this[`${animation}Animation`](entry.target)
					}
				}
			})
		}, {
			threshold: this.threshold
		})
	}

	get threshold() {
		return window.innerWidth > 768 ? 0.33 : 0.05
	}

	animateIn() {
		let elements = [].slice.call(document.querySelectorAll('[data-intersection]'))

		elements.forEach(element => {
			this.observer.observe(element)
		})
	}
	
	// Wrapper for the not-so-cleverly named animation
	// (Was created to skew elements in, but we didn't like how it
	// looked. But they'd filled the pages with `data-transition="skewin"`
	// so - it appears- they just changed what the animation did, to
	// avoid having to change all the data attributes.)
	skewinAnimation(element) {
		console.log(`Triggered 'skewin' animation on ${element.nodeName}.${element.className}`)
		this.appearAnimation(element)
	}
	
	appearAnimation(element) {
		const duration = Math.abs(element.dataset.intersectionDuration) || 1.3
		const offset = Math.abs(element.dataset.intersectionOffset) || 100
		const delay = Math.abs(element.dataset.intersectionDelay) || 0
		
		let timeline = new TimelineLite()
		timeline.fromTo(element, duration, {
			opacity: 0,
			y: offset
		}, {
			opacity: 1,
			y: 0,
			delay: delay
		})
		timeline.timeScale(1.3)
	}

	fadeUpAnimation(element) {
		const duration = Math.abs(element.dataset.intersectionDuration || 0.7)
		const offset = Math.abs(element.dataset.intersectionOffset || 175)
		const delay = Math.abs(element.dataset.intersectionDelay || 0)
		
		let timeline = new TimelineLite({ onComplete: () => {
			element.classList.add('intersected')
		}})
		
		timeline.fromTo(element, duration, {
			opacity: 0,
			y: offset
		}, {
			opacity: 1,
			y: 0,
			delay: delay
		})
	}

	fadeInRightAnimation(element) {
		let duration = Math.abs(element.dataset.intersectionDuration || 1.3)
		let offset = Math.abs(element.dataset.intersectionOffset || 100)
		let delay = Math.abs(element.dataset.intersectionDelay || 0)
		
		let timeline = new TimelineLite({ onComplete: () => {
			element.classList.add('intersected')
		}})
		
		timeline.fromTo(element, duration, {
			opacity: 0,
			x: `+=${offset}px`
		}, {
			opacity: 1,
			x: 0,
			delay: delay
		})
	}

	fadeInLeftAnimation(element) {
		let duration = Math.abs(element.dataset.intersectionDuration || 1.3)
		let offset = Math.abs(element.dataset.intersectionOffset || 100)
		let delay = Math.abs(element.dataset.intersectionDelay || 0)
		
		let timeline = new TimelineLite({onComplete: () => {
			element.classList.add('intersected')
		}})
		
		timeline.fromTo(element, duration, {
			opacity: 0,
			x: `-=${offset}px`
		}, {
			opacity: 1,
			x: 0,
			delay: delay
		})
	}
}

export default ScrollTransition
